import React from 'react';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { SignupResumeOutcome } from '../../controllers/SignupResumeViewController';
import { SignupStepUnavailable } from '../SignupStepUnavailable';

type Props = {
  outcome: SignupResumeOutcome;
  onLogIn: () => void;
  onRetry: () => void;
};

export const SignupResumeView: React.FC<Props> = ({ outcome, onLogIn, onRetry }) => {
  if (outcome === 'unavailable') {
    return <SignupStepUnavailable onRetry={onRetry} />;
  }

  if (outcome === 'expiredWithAccount') {
    return (
      <Box maxWidth={520} mx="auto">
        <Typography variant="h4" fontWeight="fontWeightSemiBold" gutterBottom>
          That signup expired
        </Typography>
        <Stack spacing={3}>
          <Typography variant="body1" color="text.secondary">
            It went unfinished for too long, so we let it go — nothing was charged. Your account itself was
            created back when you confirmed your email, and it is still yours: log in and you can finish
            setting it up from there.
          </Typography>

          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" size="large" onClick={onLogIn}>
              Log in
            </Button>
          </Box>
        </Stack>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" py={8} gap={3}>
      <CircularProgress />
      <Typography variant="body1" color="text.secondary">
        Taking you back to where you left off…
      </Typography>
    </Box>
  );
};
